import { render, staticRenderFns } from "./SelectorPremio.vue?vue&type=template&id=42a6a2ee&scoped=true"
import script from "./SelectorPremio.vue?vue&type=script&lang=js"
export * from "./SelectorPremio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a6a2ee",
  null
  
)

export default component.exports